import axios, { Method, AxiosResponse } from "axios";
import https from "https";
import { Cookie } from "../utils";
import { AppError } from "./appError";

/**
 *from user as isLoggedIn
 */
export class DataService {

  public static async axiosRequest<T>(
    method: Method,
    url: string,
    data: any
  ): Promise<T> {
    const SSOToken:any = Cookie.get();
    const token = SSOToken["ssoToken"];
    if (!token) {
      Cookie.clear();
      throw new AppError("Unauthorized Access",data,"Unauthorized Access",401,"System error",[]);
    }


    const agent = new https.Agent({
      rejectUnauthorized: false
    });
    
    try {
      const response: AxiosResponse = await axios({
        url: url,
        method: method,
        headers: {
          Authorization: token,
          "cache-control": "no-cache",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"

        },
        data: data,
        httpsAgent: agent
      });
      return response.data;
    } catch (error: any) {
    //  console.log(`------ERROR (${url} - data:${data})---------`);
     // console.log(error.response ? error.response.data : null);
    //  throw new AppError(error.response ,
    //     error.response ? error.response.data : undefined,
    //     error.response ? error.response.data?.userMessageGlobalisationCode : undefined,
    //     error.response ? error.response.status : 400,
    //     error.response ? error.response.statusText : "System error",
    //     error.response ? error.response.data?.errors : []
      return error;
      
    }
  }

  public static async get<T>(
    url: string,
    params?: Map<string, object>
  ): Promise<T> {
    return DataService.axiosRequest("get", url, undefined);
  }

  public static async post<T>(
    url: string,
    data: any,
    params?: Map<string, object>
  ): Promise<T> {
    return DataService.axiosRequest("post", url, data);
  }

  public static async patch<T>(
    url: string,
    data?: any,
    params?: Map<string, object>
  ): Promise<T> {
    return DataService.axiosRequest("patch", url, data);
  }

  public static async patchNoData<T>(
    url: string,
    params?: Map<string, object>
  ): Promise<T> {
    return DataService.axiosRequest("patch", url, undefined);
  }
  
  public static async delete<T>(
    url: string,
    params?: Map<string, object>
  ): Promise<T> {
    return DataService.axiosRequest("delete", url, undefined);
  }

  public static async put<T>(
    url: string,
    data: any,
    params?: Map<string, object>
  ): Promise<T> {
    return DataService.axiosRequest("put", url, data);
  }

  public static async withoutAuth<T>(
    url: string,
    method: Method,
    data?: any,
    params?: Map<string, object>
  ): Promise<T> {
    return DataService.axiosRequestWithoutAuth(method, url, data ? data : undefined);
  }

  public static async withoutAuthHeaders<T>(
    url: string,
    method: Method,
    data?: any,
    headers?:any,
    params?: Map<string, object>
  ): Promise<T> {
    return DataService.axiosRequestWithoutAuthHeaders(method, url, data ? data : undefined, headers);
  }

  public static async axiosRequestWithoutAuthHeaders<T>(
    method: Method,
    url: string,
    data: any,
    headers:any
  ): Promise<T> {
    const agent = new https.Agent({
      rejectUnauthorized: false
    });
      const response: AxiosResponse = await axios({
        url: url,
        method: method,
        headers: headers,
        
        data: data,
        httpsAgent: agent
      });
      return response.data;

  }

  public static async axiosRequestWithoutAuth<T>(
    method: Method,
    url: string,
    data: any
  ): Promise<T> {
    const agent = new https.Agent({
      rejectUnauthorized: false
    });

      const response: AxiosResponse = await axios({
        url: url,
        method: method,
        headers: {
          "Content-Type": "application/json"
        },
        
        data: data,
        httpsAgent: agent
      });
      return response.data;

  }

}
